import { ProviderLocation } from "generated/graphql";

const LOCATION_KEY_PREFIX = "locations_user_filter";

export function setLocationsFilterCache(locations: ProviderLocation[]) {
  localStorage.setItem(LOCATION_KEY_PREFIX, JSON.stringify(locations));
}

export function getLocationsFilterCache(): ProviderLocation[] | undefined {
  const locations = localStorage.getItem(LOCATION_KEY_PREFIX);
  return locations && JSON.parse(locations);
}
